import styled from 'styled-components';

export const PartnerOverviewContainer = styled.div`
    width: 25rem;
`;
